import { GetTeacherAPI, DelTeacherAPI, ImportUploadFileTeaApI, BatchExportTeaAPI, AddTeacherAPI, DelAllTeaAPI, GetTeaDetailAPI, PutTeacherAPI } from '@/api/teacher'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取教师
    async getTeacher({ commit }, item) {
      const res = await GetTeacherAPI(item)
      return res
    },
    // 删除教师
    async delTeacher({ commit }, item) {
      await DelTeacherAPI(item)
    },
    // 上传文件
    async uploadFile({ commit }, item) {
      await ImportUploadFileTeaApI(item)
    },
    // 批量导出教师
    async exportTeacher() {
      const res = await BatchExportTeaAPI()
      return res
    },
    // 添加教师
    async addteacher({ commit }, item) {
      await AddTeacherAPI(item)
    },
    // 删除全部教师
    async delallteacher() {
      await DelAllTeaAPI()
    },
    // 获取教师详情
    async getteadetail({ commit }, id) {
      const res = await GetTeaDetailAPI(id)
      return res
    },
    // 更新教师详情
    async putteacher({ commit }, item) {
      await PutTeacherAPI(item)
    }
  }
}
